/**
 * 弹出层
 *
 */
import initLogin from '@core/login'
import initRegister from '@core/register'

// 初使化层结构
var symbol = 'jp-sign',
  loginForm,
  registerForm,
  $_layer

// 层内容框架
function createLayerBody(type, title, switchText) {
  return (
    '<div class="' +
    symbol +
    '-body ' +
    symbol +
    '-' +
    type +
    '"><h2>' +
    title +
    '极致通行证</h2><p class="' +
    symbol +
    '-tip"></p><div id="jpSign_' +
    type +
    '">表单渲染中</div>' +
    switchButton(type === 'log' ? 'reg' : 'log', switchText) +
    closeButton() +
    '</div>'
  )
}

// 关闭按钮
function closeButton() {
  return '<button class="' + symbol + '-close"></button>'
}

// 跳转按钮
function switchButton(type, txt) {
  return (
    '<div class="' +
    symbol +
    '-footer"><button ' +
    symbol +
    '-target="' +
    type +
    '" class="' +
    symbol +
    '-switch">' +
    txt +
    '</button></div>'
  )
}

// 关闭层
function closeLayer() {
  $_layer.removeAttr(symbol + '-type')
  $_layer.removeAttr(symbol + '-single')
  $_layer.hide()

  // 解锁屏幕
  $('html, body').removeClass(symbol + '-locked')

  // 解绑窗口尺寸变化
  $(window).off('resize', positionLayer)
}

// 切换层内容
function switchLayer(config) {
  // 初使化登录
  if (config.type === 'log' && !loginForm) {
    loginForm = initLogin('jpSign_' + config.type, positionLayer, function(data) {
      successHandler(config, data)
    })
  }

  // 初使化注册
  if (config.type === 'reg') {
    if (!registerForm) {
      registerForm = initRegister('jpSign_' + config.type, positionLayer, function(data) {
        successHandler(config, data)
      })
    }

    // 动态添加gameId到注册表单
    var $_gameIdInput = registerForm.find('input[name="game_id"]')
    if (config.gameId) {
      if ($_gameIdInput.length > 0) {
        $_gameIdInput.val(config.gameId)
      } else {
        registerForm
          .find('form')
          .append('<input type="hidden" name="game_id" value="' + config.gameId + '">')
      }
    } else {
      if ($_gameIdInput.length > 0) {
        $_gameIdInput.remove()
      }
    }
  }

  $_layer.attr(symbol + '-type', config.type)
  if (config.single) $_layer.attr(symbol + '-single', config.single)
  $_layer.find('.' + symbol + '-' + config.type + ' .' + symbol + '-tip').text(config.tip)
  positionLayer()
}

// 设置弹出层位置
function positionLayer() {
  // 定位弹出层位置
  $_layer.css({
    top: $(window).scrollTop(),
    left: $(window).scrollLeft(),
    width: $(window).width(),
    height: $(window).height()
  })

  // 使弹出层内容保持居中
  var $_wrapper = $_layer.find('.' + symbol + '-wrapper')
  var wrapperHeight = $_wrapper.height(),
    marginTop = ($(window).height() - wrapperHeight) / 2
  $_wrapper.css('margin-top', marginTop < 0 ? 0 : marginTop)
}

// 打开层
function openLayer(config) {
  // 初使化层
  if (!$_layer) {
    $_layer = $(
      '<div class="' +
        symbol +
        '"><i></i><div class="' +
        symbol +
        '-wrapper">' +
        createLayerBody('log', '登录', '还没有账号？<em>立即注册</em>') +
        createLayerBody('reg', '注册', '已有账号？<em>立即登录</em>') +
        '</div></div>'
    )
    $('body').append($_layer)

    // 绑定相关事件
    $_layer.find('.' + symbol + '-close').on('click', closeLayer) // 关闭按钮
    $_layer.find('.' + symbol + '-switch').on('click', function() {
      // 登录/注册切换(部分属性在切换时可继承)
      switchLayer({
        type: $(this).attr(symbol + '-target'),
        done: config.done,
        forward: config.forward,
        gameId: config.gameId
      })
    })
  }

  // 锁定屏幕
  $('html, body').addClass(symbol + '-locked', true)
  $_layer.show()

  // 显示指定内容
  switchLayer(config)

  // 绑定窗口尺寸变化
  $(window).on('resize', positionLayer)
}

// 操作成功回调
function successHandler(config, data) {
  closeLayer()
  if (config.done) config.done(data)
  if (config.forward) location.href = config.forward
}

export default openLayer
